import instance from "../api/api";
import { useMutation, useQuery } from "@tanstack/react-query";
import { queryClient } from "../../App";
import instancePos from "../api/apiV2";
import { toast } from "react-toastify";

export const useFetchAllChartOfAccounts = (restaurantId) =>
  useQuery({
    placeholderData: (previousData) => previousData,
    queryKey: ["allChartOfAccounts", restaurantId],
    queryFn: async () => {
      const response = await instancePos.post(`/get_all_chart_of_accounts`, {
        restaurant_id: restaurantId,
      });
      return Object.values(response.data.result);
    },
  });

const getSalesReceiptData = async (restaurant_id, report_date) => {
  const body = {
    restaurant_id:
      restaurant_id === "25763" || restaurant_id === "30180"
        ? restaurant_id
        : restaurant_id,
    report_date: report_date,
  };
  const response = await instance.post("/get-sales-summary-data-v2", body);
  return response.data;
};

const getSyncLogsAndStatus = async (restaurant_id, report_date) => {
  const body = {
    restaurant_id: restaurant_id,
    report_date: report_date,
    is_for_legacy: true
  };
  const response = await instance.post("/get-sales-receipt-sync-logs", body);
  return response.data;
};

const syncReportV2 = async (body) => {
  const response = await instancePos.post(`/sync-report-v2`, body);
  return response.data;
};

const saveExpenses = async (body) => {
  const response = await instance.post("/update-expenses", body);
  return response.data;
};

const fetchUnverifiedItems = async (restaurant_id, report_date) => {
  const body = {
    restaurant_id: restaurant_id,
    report_date: report_date,
  };
  const response = await instance.post(
    "/get-unverified-menu-labor-and-discount",
    body
  );
  return response.data;
};

const fetchUnAssignedLaborReportItems = async (restaurant_id, report_date) => {
  const body = {
    restaurant_id: restaurant_id,
    date: report_date,
  };
  const response = await instance.post("/get-unassigned-labour-report", body);
  return response.data;
};

export const useFetchCombinedReport = (restaurant_id, report_date) => {
  return useQuery({
    placeholderData: (previousData, q) => previousData,
    queryKey: ["combinedReport", restaurant_id, report_date],
    queryFn: async () => {
      try {
        const body = {
          restaurant_id: restaurant_id,
          report_date: report_date,
        };
        const response = await instance.post(
          "/get-combined-raw-reports-from-s3-bucket",
          body
        );
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    onSuccess: async (data, variables, context) => {
      await queryClient.ensureQueryData(
        ["combinedReport", restaurant_id, report_date],
        data
      );
    },
  });
};

const updatePaidIns = async (body) => {
  const response = await instance.post("/update-paid-ins", body);
  return response.data;
};

const updatePaidOuts = async (body) => {
  const response = await instance.post("/update-paid-outs", body);
  return response.data;
};

export const useGetRestaurantDetails = async (restaurant_id) => {
  return useQuery({
    queryKey: ["restaurantDetails", restaurant_id],
    queryFn: async () => {
      try {
        const response = await instance.post("/get-restaurant-details", {
          restaurant_id: restaurant_id,
        });
        return response.data;
      } catch (error) {
        console.log("error", error);
      }
    },
  });
};

const getRestaurantDetails = async (restaurant_id) => {
  const response = await instance.post("/get-restaurant-details", {
    restaurant_id: restaurant_id,
  });
  return response.data;
};

export const useSyncPaidInsAndOuts = () => {
  return useMutation({
    mutationFn: async (body) => {
      const response = await instancePos.post("/sync/paid_in_out", body);
      return response.data;
    },
    onSuccess: async (data) => {
      toast.success(data.message);
    },
    onError: async (error) => {
      // toast.error("Error syncing paid ins and outs");
      toast.error(error.response.data.message);
    },
  });
};

export const useCalculateAndUpdateGrandTotal = () => {
  return useMutation({
    mutationFn: async (body) => {
      const response = await instance.post("/calculate-and-update-grand-total", body);
      return response.data;
    },
    onSuccess: async (data) => {
      toast.success(data.message);
    },
    onError: async (error) => {
      toast.error("Error calculating grand total");
    },
  });
}

export {
  getSalesReceiptData,
  saveExpenses,
  fetchUnverifiedItems,
  fetchUnAssignedLaborReportItems,
  updatePaidOuts,
  updatePaidIns,
  getRestaurantDetails,
  syncReportV2,
  getSyncLogsAndStatus
};
